import { useState, useEffect, useContext } from "react";
import { Grid, Stack, GTIWebStatus, Box, GTIWebSimpleTable, CardContent, Typography, GTIWebCardList } from "@gti-controls-v2/web-core";
import { SettingsContext } from "../../../providers/settings";
import useTicket from "../../../hooks/useTicket";
import { formatDateIsoDate } from "../../../common/utilities/dateTime";

const LinksLog = ({ TicketID }) => {
    const { handleLoading } = useContext(SettingsContext);
    const { getEnlacesByTicket } = useTicket();
    const [enlaces, setEnlaces] = useState([]);

    useEffect(() => {
        init();
        // eslint-disable-next-line
    }, []);

    const init = async () => {
        handleLoading(true);
        const result = await getEnlacesByTicket(TicketID);

        if (result.exitoso) {
            setEnlaces(result.data);
        }

        handleLoading(false);
    };

    const headersSchema = {
        title: {
            field: "EnlaceIDMap",
        },
        subtitle: {
            field: "EnlaceCreatedMap",
        },
        status: {
            field: "EnlaceMetodoEnvioDesc",
        },
    };

    const CustomStatusContent = ({ value }) => (
        <GTIWebStatus
            label={value}
            status={value}
            statusList={{
                'WhatsApp': {
                    color: 'WhatsApp',
                },
                'Correo': {
                    color: 'Correo'
                }
            }}
            datasource={
                {
                    'WhatsApp': {
                        bgColor: '#25D366',
                        textColor: '#ffffff'
                    },
                    'Correo': {
                        bgColor: '#1A73E8',
                        textColor: '#ffffff'
                    }
                }
            }
        />
    );

    const CustomDetailPanelContent = ({ data }) => {
        const columns = [
            { field: "EnlaceLogID", headerName: "ID", width: 50 },
            { field: "Version", headerName: "Version App", width: 100 },
            { field: "StatusDesc", headerName: "Estado del enlace", width: 150 },
            { field: "IP", headerName: "IP", width: 150 },
            { field: "Device", headerName: "Dispositivo", width: 150 },
            { field: "UsuarioID", headerName: "UsuarioID", width: 100 },
            { field: "Fecha", headerName: "Creado", width: 200, domain: "fecha_hora" }
        ];

        return (
            <CardContent>
                <Stack spacing={2}>
                    <Typography variant="h6">
                        Registros del Enlace #{data.EnlaceID}
                    </Typography>

                    <Box>
                        Origen: <b>{data.EnlaceOrigenDesc}</b>
                    </Box>
                    <Box>
                        Tipo: <b>{data.EnlaceTipoDesc}</b>
                    </Box>
                    <Box>
                        Token de rastreo: <b>{data.EnlaceToken}</b>
                    </Box>
                    <Box>
                        Descripción: <b>{data.EnlaceDescripcion}</b>
                    </Box>

                    <GTIWebSimpleTable
                        columns={columns}
                        rows={data.Logs}
                    />
                </Stack>
            </CardContent>
        );
    };

    const cards = enlaces.map(e => ({
        ...e,
        EnlaceIDMap: `Enlace #${e.EnlaceID}`,
        EnlaceCreatedMap: `Creado: ${formatDateIsoDate(e.EnlaceCreated, true)}`
    }));


    return (
        <Grid marginTop={4}>
            <Grid container direction="column">
                <GTIWebCardList
                    headersSchema={headersSchema}
                    cards={cards}
                    statusContent={<CustomStatusContent />}
                    detailPanelContent={<CustomDetailPanelContent />}
                />
            </Grid>
        </Grid>
    );
};

export default LinksLog;